import { createContext, useEffect, useState } from 'react';

export const ThemeContext = createContext();

const themes = {
  '#004A9A': 'theme-blue',
  '#DA5C19': 'theme-orange',
  '#262626': 'theme-black',
  '#964B00': 'theme-brown',
};

export const ThemeProvider = ({ children }) => {
  const [themeColor, setThemeColor] = useState('#004A9A');

  useEffect(() => {
    const themeClass = themes[themeColor] || 'theme-blue';
    document.body.className = themeClass;
  }, [themeColor]);

  return (
    <ThemeContext.Provider value={{ themeColor, setThemeColor }}>
      {children}
    </ThemeContext.Provider>
  );
};
